import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import LRMessage from '../../components/LRMessage';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.ChargeUpFast');
    const { locale = 'us' } = useRouter();
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-ChargeUpFast'} data-section-title={t('title')}>
            <div className="comp-module">
                <div className="comp-title">{t('title')}</div>
                <div className="comp-img">
                    <EditorImg
                        pc={
                            locale === 'cn'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1737788662047/9.jpg'
                                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718708799219/b1%20(1).jpg'
                        }
                        h5={
                            locale === 'cn'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1737788661876/9_M.jpg'
                                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799648973/b1.jpg'
                        }
                    />
                </div>
                <LRMessage lTitle={t('item1_l')} rTitle={t('item1_r')} rTips={t('item1_tip')} />
            </div>
        </div>
    );
};

export default TheComp;
